export const normalizeNumber = (value: string | number): number => {
    if (value === null || value === undefined) {
        return 0;
    }
    const str = `${value}`.trim();
    const normalized = str.replace(',', '.');
    const cleaned = normalized.endsWith('.') ? normalized.slice(0, -1) : normalized;
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
};

export const roundNumber = (
    number: number,
    decimals: number = 2,
): number => {
    const value = normalizeNumber(number);
    const factor = 10 ** decimals;
    const n = value * factor;
    return Math.round(n) / factor;
};
